import * as React from 'react';
import { useParams, useRouteMatch } from 'react-router-dom';
import { useUser } from '../../hooks/use-user';
import { Grid, Flex } from '../../ui';
import AccountLink from './AccountLink';
import DownloadButton from './DownloadButton';
import MainMenu from './MainMenu';
import NavLinks from './NavLinks';

const Header = () => {
  const user = useUser();
  const isDark = !!useRouteMatch('/resumes/:id/preview');
  const { resumeId } = useParams<{ resumeId?: string }>();

  if (!resumeId) return null;

  return (
    <Grid variant="header">
      <Flex
        sx={{
          justifyContent: 'flex-start',
          alignItems: 'center',
          // Offset the left padding from the button
          ml: -3,
        }}
      >
        <MainMenu isDark={isDark} />
      </Flex>
      <Flex
        sx={{
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Flex
          sx={{
            justifyContent: ['center', 'center', 'flex-start'],
            alignItems: 'center',
            ml: [0, 0, -22],
          }}
        >
          <NavLinks activeResumeId={resumeId} isDark={isDark} />
        </Flex>

        <Flex
          sx={{
            justifyContent: 'flex-end',
            alignItems: 'center',
            // Offset the right padding from the download button
            mr: -3,
          }}
        >
          {user && !user.isAnonymous ? (
            <AccountLink user={user} isDark={isDark} />
          ) : null}
          <DownloadButton resumeId={resumeId} user={user} />
        </Flex>
      </Flex>
    </Grid>
  );
};

export default Header;
